// LAP-550 — Card Marché Financier : header + segmenter (pills) + MarketTable + actualités
import { Box, Stack, ButtonBase } from '@mui/material'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import CardHeader from '../../_shared/CardHeader'
import MarketTable from '../../_shared/MarketTable'
import { invTheme } from '../../_shared/theme'

// Mapping types → clé de variation présente dans les données
const VARIATION_KEY = {
  market_financier: 'variation_1d',
  market_obligation: 'variation_1_jour',
  market_europeen: 'variation_1d',
  market_americain: 'variation_1d',
  market_etf: 'variation_1_jour',
}

export default function MarketCard({ result = [] }) {
  const { t } = useTranslation('layout')
  const [viewData, setViewData] = useState({})
  useEffect(() => {
    if (result.length > 0) setViewData(result[0])
  }, [result])
  const handelbutton = (type) => {
    setViewData(result.find((r) => r.type === type))
  }
  // LAP-733 (GE022) — pré-remplissage de l'ajout d'opportunité depuis cette
  // liste de valeurs ; les tableaux de ce card utilisent soit variation_1d
  // soit variation_1_jour selon le marché, jamais les deux.
  const buildOpportunityValues = (item) => ({
    name: item.name,
    price: item.price,
    market_id: (item.symbol || '').slice(0, 5),
    value_change_pct: item.variation_1d ?? item.variation_1_jour,
  })

  const variationKey = VARIATION_KEY[viewData?.type] || 'variation_1d'
  const showNews = viewData?.type === 'market_europeen' || viewData?.type === 'market_americain'
  return (
    <Box display="flex" flexDirection="column" height="100%">
      <CardHeader
        icon="/images/download.svg"
        title={t('investments.markeet.market.title')}
        subtitle={viewData?.title}
      />
      <Box
        mt={2}
        height="100%"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {viewData?.button && (
          <Stack
            direction="row"
            spacing={0.5}
            sx={{
              mb: 1.5,
              p: 0.25,
              borderRadius: 999,
              backgroundColor: 'rgba(255,255,255,0.04)',
              alignSelf: 'flex-start',
            }}
          >
            {viewData.button.map((b, idx) => {
              const active = b.type === viewData?.type
              return (
                <ButtonBase
                  key={idx}
                  onClick={() => handelbutton(b.type)}
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    fontSize: 11,
                    fontWeight: 600,
                    borderRadius: 999,
                    color: active ? '#001b42' : 'rgba(255,255,255,0.65)',
                    backgroundColor: active ? '#cfe1ff' : 'transparent',
                    textTransform: 'uppercase',
                    letterSpacing: 0.4,
                    transition: 'all 150ms ease',
                    '&:hover': {
                      backgroundColor: active ? '#cfe1ff' : 'rgba(255,255,255,0.06)',
                    },
                  }}
                >
                  {b.name}
                </ButtonBase>
              )
            })}
          </Stack>
        )}
        <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
          {viewData?.data && (
            <MarketTable
              data={viewData.data}
              variationKey={variationKey}
              maxHeight={showNews ? 200 : 320}
              getOpportunityValues={buildOpportunityValues}
            />
          )}
          {showNews && (
            <Box mt={1.5} sx={{ borderTop: '1px dashed rgba(255,255,255,0.08)', pt: 1 }}>
              <Box sx={invTheme.subtitle}>{t('investments.markeet.market.allNews')}</Box>
              {viewData?.news?.map((item, index) => (
                <Box key={index} display="flex" sx={{ fontSize: 12, mt: 0.5 }}>
                  <Box mr={1} sx={{ color: 'rgba(255,255,255,0.45)', whiteSpace: 'nowrap', fontSize: 11 }}>
                    {moment(item.published_at).fromNow()}
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>{item.title}</Box>
                </Box>
              ))}
              <Box sx={{ color: 'rgba(255,255,255,0.4)', mt: 1, textAlign: 'center', fontSize: 11 }}>
                {t('investments.markeet.market.moreNews')}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}
